<template>
  <v-container>
    <v-row>
      <v-col>
        <material-table
            ref="device_list"
            title="交换机列表"
            :url="device.table.api"
            :columns="device.table.headers"
            :data="device.table.list"
            :filter="device.table.filter"
            :searchValue="device.table.searchValue"
        >
          <template slot="title">
            <v-btn color="primary" @click="searchTable('device_list')">搜索</v-btn>
            <!--            <v-btn color="primary" class="ml-5" @click="showDialog('device_add')">添加Ap组</v-btn>-->
          </template>
          <!-- title -->
          <template slot="body">
            <v-card-subtitle>
              <v-row>
                <v-col cols="12" xs="12" sm="4" md="2" class="pt-0 pb-0">
                  <v-text-field
                      v-model="device.table.filter.mac"
                      placeholder="请输入mac地址"
                      label="mac"
                      append-outer-icon="search"
                      @click:append-outer="searchTable('device_list')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-subtitle>
            <!-- 选择框 -->
          </template>
          <!-- search -->
          <template slot="action" slot-scope="data">
            <a class="span" v-if="data.value.item.status === '0'"  @click="showApGroupEdit(data.value.item)"><v-icon small>mdi-pencil</v-icon> 添加</a>
            <el-tag v-else type="success">已添加</el-tag>
          </template>
          <!-- action -->
        </material-table>

      </v-col>
    </v-row>

    <!-- AP列表 -->
  </v-container>
</template>
<script>
import axios from 'axios'
import api from '@/api.js'
import { Notification } from 'element-ui'
export default {
  data() {
    return {
      device: {
        set:{},
        class:{},
        table: {
          api:api.device.switchList,
          searchValue:0,
          headers: [
            { text: 'mac', value: 'mac' },
            { text: '状态', value: 'online_status' },
          ],
          list: [],
          filter: {
            device_name: "",
            group_id: null,
            shop_id: null,
            mac: '',
          },
          shop_list:[],
          class: [],
          set: [],
        },
        group_list:[],
        add_dialog: {
          shop_list:[],
          data:{
            device_name: "",
            group_id: null,
            shop_id: null,
            set_id:'',
            class_id:''
          }
        },
        edit_dialog: {
          shop_list:[],
          data:{
            mac: "",
            ip: "",
            set_id:'',
            class_id:''
          }
        },
        del_dialog: {
          data: {
            device_id: null
          }
        }
      },
      ap: {
        table: {
          button:{
            download_ap_template_loading: false
          },
          api:api.device.apList,
          searchValue:0,
          headers: [
            { text: 'Mac地址', value: 'mac' },
            { text: '状态', value: 'online_status' },
          ],
          list: [],
          filter: {
            apmac: "",
            device_id: null,
          }
        },
        add_dialog: {
          data:{
            apmac: "",
            remark: "",
            device_id: null,
          }
        },
        edit_dialog: {
          data:{
            ap_id: null,
            apmac: "",
            remark: "",
            device_id: null,
            set_id: '',
            class_id:''
          }
        },
        del_dialog: {
          data: {
            ap_id: null
          }
        },
        import_dialog: {
          data: {
            file: null
          }
        },
        device_list:[]
      },
      userParams:{
        set_id: '',
        username: '',
      }
    }
  },
  mounted() {
  },
  created() {
    this.getClassList()
  },
  methods : {
    /**
     * 通用函数
     */
    showDialog(ref_name){
      this.$refs[ref_name].showDialog()
    },
    closeDialog(ref_name){
      this.$refs[ref_name].closeDialog()
    },
    reflushTable(ref_name){
      if(ref_name == "device_list" || ref_name == "device_edit")
      {
        this.searchTable(ref_name)
      }
      // this.$refs[ref_name].getDataFromApi()
    },
    searchTable(ref_name){
      this.$refs[ref_name].searchTable()
    },
    ReFresh(ref_name){
      this.$refs[ref_name].reset()
    },
    /**
     * 显示Dialog
     */
    showApGroupEdit(item){
      this.device.edit_dialog.data = {
        mac: item.mac,
        ip: item.ip,
      }
      // this.handleEditClassChange()
      let _this = this
      this.device.set.forEach(function(item, index) {
        //item 就是按循环到的对象
        //index是循环的索引，从0开始
        if (item.is_mac == 1){
          _this.device.edit_dialog.data.set_id = item.id.toString()
        }
      })
      this.getSetList()
      this.showDialog("device_edit")
    },
    showApGroupDel(item){
      this.device.del_dialog.data = {
        device_id: item.id
      }
      this.showDialog("device_del")
    },
    showApEdit(item) {
      this.ap.edit_dialog.data = {
        ap_id: item.id,
        apmac: item.mac,
        remark: item.remark,
        device_id: item.group_id
      }
      this.showDialog("ap_edit")
    },
    showApDel(item) {
      this.ap.del_dialog.data = {
        ap_id: item.id
      }
      this.showDialog("ap_del")
    },
    /**
     * 获取选择列表
     */
    getClassList(){
      this.$http.get(api.aaa.authSet).then(resp => {
        if(resp.errno !== 0)
          return
        this.device.set = resp.data
      }).finally(resp => {})
    },
    getSetList(){
      this.loadingUser = true;
      this.userParams.setID = this.device.edit_dialog.data.set_id;
      this.$http.post(api.aaa.authClass,this.userParams).then(resp => {
        if(resp.errno == 0){
          this.device.class = resp.data
          this.device.edit_dialog.data.class_id = this.device.class[0].id.toString()
          this.loadingUser = false;
        }
      }).finally(resp => {})
    },
    handleEditClassChange(){
      this.getSetList()
    },
    getDeviceList(){
      this.$http.post(api.device.switchList, this.device.table.filter).then(resp => {
        if(resp.errno !== 0)
          return
        this.device.table.list = resp.list
      }).finally(resp => {})
    },
    handleSearchGroupChange(){
      let group_id_checked = this.device.table.filter.group_id
      if(typeof group_id_checked == 'undefined' || group_id_checked == null)
      {
        this.device.table.filter.shop_id = null
        this.device.table.shop_list = []
      }
      else
      {
        // 获取shoplist
        this.getSetList().then((res) => {
          this.device.table.shop_list = res.list
        })
      }
    },
  }
}
</script>
